import React, { useState } from "react";
import { NavLink as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Button, Collapse, ListItem, makeStyles } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

const useStyles = makeStyles((theme) => ({
  item: {
    display: "block",
    paddingTop: 0,
    paddingBottom: 0,
  },
  itemLeaf: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
    padding: "0px 10px",
  },
  button: {
    color: "#000000",
    padding: "10px 0",
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    width: "100%",
  },
  buttonLeaf: {
    color: "rgba(255, 255, 255, 0.6)",
    padding: "12px 8px",
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    width: "100%",
    // borderLeft: "solid 8px transparent",
    borderRadius: 0,
    fontSize: "16px",
    margin: "2px 5px",
    "&:hover": {
      // borderRight: "8px solid #AC7AE4",
      color: " #fff",
      // background: "#FF2626",
      borderRadius: " 13.1483px",

      background: "linear-gradient(180deg, #f2e4d5 0%, #4500ff 100%)",
    },
    "&.depth-0": {
      "& $title": {
        fontWeight: "300",
      },
    },
  },
  icon: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(3),
    marginLeft: theme.spacing(1),
    color: "rgba(255, 255, 255, 0.6)",
    "& svg": {
      color: "#AC7AE4",
    },
  },
  title: {
    marginRight: "auto",
  },
  active: {
    color: "#fff",
    background: "linear-gradient(180deg, #f2e4d5 0%, #4500ff 100%)",
    borderRadius: " 13.1483px",
    // borderLeft: "8px solid #FF2626",
    margin: "0px 5px",
    // borderColor: theme.palette.secondary.main,
    fontWeight: theme.typography.fontWeightRegular,
    "& $title": {
      fontWeight: theme.typography.fontWeightMedium,
    },
    icon: {
      color: "#fff",
      "& svg": {
        color: "#fff",
      },
    },
    "& $icon": {
      color: "#fff",
    },
  },
}));

const NavItem = ({
  children,
  className,
  depth,
  href,
  icon: Icon,
  info: Info,
  open: openProp,
  title,
  ...rest
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(openProp);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  let paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  const style = { paddingLeft };
  console.log(href, " --- fgsd ", window.location.pathname.includes(href));
  if (children) {
    return (
      <ListItem
        className={clsx(classes.item, className)}
        disableGutters
        key={title}
        {...rest}
      >
        <Button
          className={classes.button}
          onClick={handleToggle}
          style={{ color: "#ccc" }}
        >
          {Icon && <Icon className={classes.icon} size="20" />}
          <span className={classes.title}>{title}</span>
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Button>
        <Collapse in={open}>{children}</Collapse>
      </ListItem>
    );
  }

  return (
    <ListItem
      className={clsx(classes.itemLeaf, className)}
      disableGutters
      key={title}
      {...rest}
    >
      <Button
        activeClassName={classes.active}
        className={
          window.location.pathname.includes(href)
            ? clsx(classes.active, classes.buttonLeaf, `depth-${depth}`)
            : clsx(classes.buttonLeaf, `depth-${depth}`)
        }
        component={RouterLink}
        exact
        style={style}
        to={href}
      >
        {Icon && <Icon className={classes.icon} size="20" />}
        <span className={classes.title}>{title}</span>
        {Info && <Info />}
      </Button>
    </ListItem>
  );
};

NavItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  info: PropTypes.elementType,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

NavItem.defaultProps = {
  open: false,
};

export default NavItem;
